import React from 'react';
import Wizard from './Wizard';
import { resolveWizardAction } from '../Services/wizard.service';

interface Props {
	wizardKey: string;
	initialData?: object;
	keepInitialData?: boolean;
	keepStepsData?: boolean;
	wizardTitleStyle?: React.CSSProperties;
	wizardDescriptionStyle?: React.CSSProperties;
}

const WizardWrapper: React.FC<Props> = ({
	wizardKey,
	initialData,
	keepInitialData,
	keepStepsData,
	wizardTitleStyle,
	wizardDescriptionStyle,
}) => {
	return (
		<Wizard
			wizardKey={wizardKey}
			initialData={initialData}
			onWizardDone={resolveWizardAction}
			keepInitialData={keepInitialData}
			keepStepsData={keepStepsData}
			wizardTitleStyle={wizardTitleStyle}
			wizardDescriptionStyle={wizardDescriptionStyle}
		/>
	);
};

export default WizardWrapper;
